import ApiService from "../api";

function montarParams(filtros = {}) {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([chave, valor]) => {
        if (valor !== null && valor !== undefined && valor !== "") params.append(chave, valor);
    });
    return params;
}

export default class RenovacaoGdmService extends ApiService {

    constructor() {
        super('/api/solicitacoes/renovacao-gdm')
    }

    criarSolicitacao(dados) {
        return this.post(``, dados)
    }

    buscarDetalhe(solicitacaoId) {
        return this.get(`/${solicitacaoId}`)
    }

    /** Edita os dados na etapa inicial (sem enviar — o envio continua sendo a ação ENVIAR). */
    editarSolicitacao(solicitacaoId, dados) {
        return this.put(`/${solicitacaoId}`, dados)
    }

    /** Cliente + GDMs dele na base + renovações já solicitadas. `codigo` no formato 9999-9999. */
    consultarCliente(codigo) {
        return this.get(`/consulta-cliente/${codigo}`)
    }

    relatorio(filtros = {}) {
        return this.get(`/relatorio?${montarParams(filtros)}`);
    }

    dashboard(filtros = {}) {
        return this.get(`/dashboard?${montarParams(filtros)}`);
    }

    resumoBaseGdm() {
        return this.get(`/base-gdm/resumo`)
    }

    /** Filtros opcionais: termo, rota, cidade, canal, gdmStatus, logomarca, origem. Devolve { total, limite, registros }. */
    listarBaseGdm(filtros = {}) {
        return this.get(`/base-gdm?${montarParams(filtros)}`)
    }

    /** Valores distintos para filtros: { rotas, cidades, canais, gdmStatus, logomarcas }. */
    opcoesBaseGdm() {
        return this.get(`/base-gdm/opcoes`)
    }

    criarBaseGdm(dados) {
        return this.post(`/base-gdm`, dados)
    }

    atualizarBaseGdm(id, dados) {
        return this.put(`/base-gdm/${id}`, dados)
    }

    excluirBaseGdm(id) {
        return this.delete(`/base-gdm/${id}`)
    }

    excluirBaseGdmEmLote(ids) {
        return this.post(`/base-gdm/excluir`, { ids })
    }

    /** Relatório de conclusão (base x renovações). Filtros opcionais: dataInicial, dataFinal, cliente, rota, cidade, canal, gdmStatus, logomarca. */
    conclusaoBaseGdm(filtros = {}) {
        return this.get(`/base-gdm/conclusao?${montarParams(filtros)}`)
    }

    /** `formData` com o campo "file" (planilha Excel). */
    importarBaseGdm(formData) {
        return this.post(`/base-gdm/importar`, formData)
    }
}
